import {
  Identifiable,
  Project,
  Zone,
  ZoneProjectsRetrievalFilter,
} from "@planzone/dto";

enum SortOptions {
  Default = "zonePage.projects.sorter.default",
  AscendingAlphabeticalOrder = "zonePage.projects.sorter.ascendingAlphabeticalOrder",
  DescendingAlphabeticalOrder = "zonePage.projects.sorter.descendingAlphabeticalOrder",
  StartDate = "zonePage.projects.sorter.startDate",
  EndDate = "zonePage.projects.sorter.endDate",
  CreationDate = "zonePage.projects.sorter.creationDate",
}

type SortFunctions = {
  [key in SortOptions]: (
    data: Identifiable<Project>[],
  ) => Identifiable<Project>[];
};

interface Props {
  zone: Identifiable<Zone>;
  filter: ZoneProjectsRetrievalFilter;
}

export type { Props, SortFunctions };

export { SortOptions };
